import type React from 'react';
import styles from './Specifications.module.css';

interface UrlAvailabilityStatusProps {
  checking?: boolean;
  checkProgress?: { checked: number; total: number } | null;
  checkResult?: 'available' | 'unavailable' | null;
  onCheckAvailability?: () => void;
}

export const UrlAvailabilityStatus: React.FC<UrlAvailabilityStatusProps> = ({
  checking,
  checkProgress,
  checkResult,
  onCheckAvailability,
}) => {
  return (
    <>
      <div className={styles.urlCheckSection}>
        <div className={styles.urlCheckLabel}>API Availability</div>
        {checking && (
          <div className={styles.urlCheckStatus} data-status="checking">
            <span className={styles.urlCheckDot} data-status="checking" />
            Checking...{checkProgress ? ` ${checkProgress.checked}/${checkProgress.total}` : ''}
            {checkProgress && (
              <div className={styles.urlCheckProgressBar}>
                <div
                  className={styles.urlCheckProgressFill}
                  style={{ width: `${(checkProgress.checked / checkProgress.total) * 100}%` } as React.CSSProperties}
                />
              </div>
            )}
          </div>
        )}

        {!checking && checkResult === 'available' && (
          <div className={styles.urlCheckStatus} data-status="available">
            <span className={styles.urlCheckDot} data-status="available" />
            Available
          </div>
        )}

        {!checking && checkResult === 'unavailable' && (
          <div className={styles.urlCheckStatus} data-status="unavailable">
            <span className={styles.urlCheckDot} data-status="unavailable" />
            Unavailable
          </div>
        )}

        {!checking && !checkResult && (
          <div className={styles.urlCheckStatus} data-status="idle">
            <span className={styles.urlCheckDot} data-status="idle" />
            Not checked
          </div>
        )}
      </div>

      {onCheckAvailability && (
        <div className={styles.urlCheckActions}>
          <button
            className={styles.smallButton}
            data-variant="primary"
            onClick={onCheckAvailability}
            disabled={checking}
          >
            {checking ? 'Checking...' : 'Check Availability'}
          </button>
        </div>
      )}
    </>
  );
};
